<template>
    <div>
        <breadcrumb :routerList="[{to:'/dingd/dingdmainlist',title:'订单管理'},{title:'订单审批'}]"
                    v-if="this.taskstatus == '0'"/>
        <breadcrumb :routerList="[{to:'/dingd/dingdmainlist',title:'订单管理'},{title:'订单详情'}]"
                    v-if="this.taskstatus == '1'"/>
        <orderNxsp
                :orderid="order.orderid"
                :orderinstid="order.orderinstid"
                :ordertaskid="order.ordertaskid"
                :ordertaskstatus="order.ordertaskstatus"
        />

    </div>
</template>

<script>
    import orderNxsp from '../../components/order/orderNxshenpi'
    export default {
        components:{orderNxsp},
        data(){
          return{
              taskstatus:1,
              order:{
                  orderid:"",
                  orderinstid:"",
                  ordertaskid:"",
                  ordertaskstatus:"",
              }
          }
        },
        created(){
            let id = this.$route.query.ywid || this.$route.query.id;
            let instid = this.$route.query.instid;
            let taskid = this.$route.query.taskid;
            let taskstatus = this.$route.query.taskstatus;
            this.taskstatus = taskstatus;
            this.order.orderid=id;
            this.order.orderinstid=instid;
            this.order.ordertaskid=taskid;
            this.order.ordertaskstatus=taskstatus;
        },
        beforeRouteLeave(to,from,next){
            if(to.path=='/dingd/orderProcess' && from.path == '/dingdmain/orderNxshenpi'){
                to.meta.keepAlive = true;
            }else{
                to.meta.keepAlive = false;
            }
            next();
        },
    }

</script>
